<header>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <a class="navbar-brand" href="#">
        <img src="assets/images/default-logo.svg" alt="" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
        <ul class="navbar-nav ml-auto mr-auto mt-2 mt-lg-0">
          <li class="nav-item">
            <a
              class="nav-link"
              [class.activeLink]="activeNav"
              (click)="goToDashboard()"
              >Dashboard</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              [class.activeLink]="activeCourse"
              (click)="gotoCourses()"
              >My Courses</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              [class.activeLink]="activePath"
              (click)="goToLearningPath()"
              >Learning Path</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              [class.activeLink]="activePath"
              (click)="goToCategories()"
              >Manage Categories</a
            >
          </li>

          <!-- <li class="nav-item">
            <a
              class="nav-link"
              [class.activeLink]="activeSet"
              (click)="goToSettings()"
              >Settings</a
            >
          </li> -->
        </ul>
        <ul class="navbar-nav drop-down mt-2 mt-lg-0">
          <li class="nav-item dropdown mt-2">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Hi, {{ userDatils?.full_name }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" href="profile">Profile</a>
              <a class="dropdown-item" href="profile">Settings</a>
              <a class="dropdown-item" (click)="logout()">Logout</a>
            </div>
          </li>
          <li class="nav-item with-img">
            <img
              src="{{
                userDatils?.avatarUrl
                  ? userDatils?.avatarUrl
                  : 'assets/images/avatar.jpg'
              }}"
              alt=""
            />
          </li>
          <li
            class="nav-item noti-icon mt-2 ml-2"
            drawer-trigger="notification"
          >
            <img src="/assets/icons/noti-icon.svg" alt="" />
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
<!-- <app-notification></app-notification> -->
